import React from 'react';

const AssessmentBanner = ({ assessment }) => {
  return (
    <>
      <div className="assessment-image">
        <img alt={assessment.shortTitle} src={assessment.logo} height={450} />
      </div>
      <style jsx>{`
        .assessment-image {
          width: 50%;
          overflow: hidden;
          max-height: 600px;
        }
        .assessment-image img {
          object-fit: cover;
        }
        @media only screen and (max-width: 768px) {
          .assessment-image {
            order: -1;
            width: 100%;
            height: 300px;
          }
        }
      `}</style>
    </>
  );
};

export default AssessmentBanner;
